exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".floating-right-div[data-v-518403a5] {\n  --top: 100px;\n  --width: 35%;\n  --bottom: 350px;\n  width: var(--width);\n  height: calc(var(--bottom));\n  transform: translate(0, var(--top));\n  float: right;\n  shape-outside: polygon(0 var(--top), var(--width) var(--top), var(--width) var(--bottom), 0 var(--bottom));\n  -webkit-clip-path: polygon(0 0, var(--width) 0, var(--width) calc(var(--bottom) - var(--top)), 0 calc(var(--bottom) - var(--top)));\n          clip-path: polygon(0 0, var(--width) 0, var(--width) calc(var(--bottom) - var(--top)), 0 calc(var(--bottom) - var(--top)));\n}", ""]);

// exports
